// Keeps the iOS Safari status-bar / Dynamic Island colour in sync with the
// hotel's active theme. Without this the <meta name="theme-color"> from
// index.html (a hard-coded default) shows through on mobile Safari.
//
// We update the <meta> tag whenever a hotel theme is applied or cleared.
export function updateMetaThemeColor(color: string | undefined | null): void {
  let meta = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
  if (!meta) {
    meta = document.createElement('meta');
    meta.name = 'theme-color';
    document.head.appendChild(meta);
  }
  // Fall back to white (matches default top-nav-bar background) when no colour is supplied
  meta.content = color || '#ffffff';
}
